module.exports = __webpack_public_path__ + "static/media/dark_bg-login.d26cbaed.svg";